<common-confirm></common-confirm>


<h1 class="container-heading">Model fields List</h1>

<mat-card>
    <mat-card-content>

        <common-table *ngIf="listTable" [options]="listTable" (action)="handleListAction($event)">
            <div data-actions *ngIf="userService.validatePermissions('add_model_fields')">
                <a routerLink="add" mat-raised-button color="primary"
                   class="create">Add</a>
            </div>
        </common-table>

    </mat-card-content>
</mat-card>
